import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-label" }
const _hoisted_2 = { class: "p-label" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "p-hint" }, "This is your login", -1)
const _hoisted_4 = { class: "p-label" }
const _hoisted_5 = { class: "p-field mb-4" }
const _hoisted_6 = { class: "p-label" }
const _hoisted_7 = { class: "p-field mb-4" }
const _hoisted_8 = { class: "p-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileCard = _resolveComponent("ProfileCard")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ProfileCard, {
      name: $setup.data.name,
      credits: $setup.data.credits,
      tokens: $setup.data.tokens
    }, null, 8, ["name", "credits", "tokens"]),
    _createElementVNode("form", {
      onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => ($setup.handleSubmit(!$setup.v$.$invalid)), ["prevent"])),
      class: "_form _relative"
    }, [
      ($setup.isLoading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            isOverlay: ""
          }))
        : _createCommentVNode("", true),
      _createElementVNode("label", {
        class: _normalizeClass(["p-field mb-4", { 'p-invalid': $setup.v$.name.$invalid && $setup.v$.name.$dirty }])
      }, [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('username')), 1),
        _createVNode(_component_InputText, {
          type: "text",
          modelValue: $setup.v$.name.$model,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.v$.name.$model) = $event)),
          onBlur: _cache[1] || (_cache[1] = ($event: any) => ($setup.v$.name.$touch()))
        }, null, 8, ["modelValue"])
      ], 2),
      _createElementVNode("label", {
        class: _normalizeClass(["p-field mb-4", { 'p-invalid': $setup.v$.email.$invalid && $setup.v$.email.$dirty }])
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('email')), 1),
        _createVNode(_component_InputText, {
          type: "email",
          modelValue: $setup.v$.email.$model,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.v$.email.$model) = $event)),
          onBlur: _cache[3] || (_cache[3] = ($event: any) => ($setup.v$.email.$touch()))
        }, null, 8, ["modelValue"]),
        _hoisted_3
      ], 2),
      _createElementVNode("label", {
        class: _normalizeClass(["p-field mb-4", { 'p-invalid': $setup.v$.phone.$invalid && $setup.v$.phone.$dirty }])
      }, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('profile.phone')), 1),
        _createVNode(_component_InputText, {
          type: "tel",
          modelValue: $setup.v$.phone.$model,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.v$.phone.$model) = $event)),
          onBlur: _cache[5] || (_cache[5] = ($event: any) => ($setup.v$.phone.$touch()))
        }, null, 8, ["modelValue"])
      ], 2),
      _createElementVNode("label", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('profile.total_credit')), 1),
        _createVNode(_component_InputNumber, {
          type: "text",
          modelValue: $setup.data.credits,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.credits) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("label", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('profile.available_tokens')), 1),
        _createVNode(_component_InputNumber, {
          type: "text",
          modelValue: $setup.data.tokens,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.data.tokens) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_component_Button, {
        class: "p-button-big _full-width",
        type: "submit",
        disabled: $setup.isSubmiting
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('profile.add_employee')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ], 32)
  ], 64))
}